import React, {Component, Fragment} from 'react';
import ScrollArea from '../scrollbar';
import { Link } from 'react-router-dom';
import logo from '../../../images/thoot.png';
import ReactTooltip from 'react-tooltip';

// icons

import MdClose from 'react-icons/lib/md/close';

import './style.css';
import {globals} from '../../../../../common/constants';
import NavLink from "react-router-dom/NavLink";

const NavHead = (props) => {
    const navBig = document.body.clientWidth > globals.NAV_BIG;
    const {
        isLeftMenuOpened
    } = props;

    return (
        <header className="nav-head">
            {
                !navBig && <span className="kr kr-close" onClick={props.toggleNav}/>
            }
            {isLeftMenuOpened &&
                <div>
                    <span className="kr kr-close" onClick={props.setLeftMenu}/>
                    <div className="menu-logo">
                        <Link to="/sm-admin">
                            <img src={logo} alt="Kerenor Booking" />{}
                        </Link>
                    </div>
                </div>
            }
            {!navBig && <div className="menu-logo">
                <Link to="/sm-admin">
                    <img src={logo} alt="Kerenor Booking" />
                </Link>
            </div>}
            {navBig && !props.isLeftMenuOpened &&
            <div className="collapsed_menu_burger">
                <span onClick={props.setLeftMenu} className="kr kr-menu" />
            </div>
            }
        </header>
    );
}

class NavList extends React.Component {
    constructor(props) {
        super(props);
        this.navBig = document.body.clientWidth > globals.NAV_BIG
        const route = window.location.pathname.replace('sm-admin/','');
        this.state = {
            selected: route  === '/sm-admin' ? '/' : route
        }
    }
    
    handleClick = (e,index) => {
        let c = e.currentTarget.className;
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            selected: window.location.pathname.replace('sm-admin/',''),
            isLeftMenuOpened :!this.state.isLeftMenuOpened
        });
        this.props.toggleNav()
    }

    render() {
        return (
            <ScrollArea className="nav-list-container" horizontal={false} verticalScrollbarStyle={{width: '4px', marginLeft: '10px'}}>
                <ul className="list-menu nav-list clearfix">
                    <li onClick={(event)=>this.handleClick(event, '/')} className={(this.state.selected === '/') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/" data-for='dashboard-tooltip' data-tip='Dashboard'>
                            <span className="kr kr-dashboard" />
                            <span className="name">Dashboard</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/dentists')} className={(this.state.selected === '/dentists') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/dentists" data-for='dentists-tooltip' data-tip='Dentists'>
                            <span className="kr kr-dentists" />
                            <span className="name">Dentists</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/patients')} className={(this.state.selected === '/patients') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/patients" data-for='patients-tooltip' data-tip='Patients'>
                            <span className="kr kr-patients" />
                            <span className="name">Patients</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/cases')} className={(this.state.selected === '/cases') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/cases" data-for='cases tooltip' data-tip='Cases'>
                            <span className="kr kr-cases" />
                            <span className="name">Cases</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/available-units')} className={(this.state.selected === '/available-units') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/available-units" data-for='av-tooltip' data-tip='Available Units'>
                            <span className="kr kr-available-units" />
                            <span className="name">Available Units</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/daily-report')} className={(this.state.selected === '/daily-report') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/daily-report" data-for='dr-tooltip' data-tip='Daily Reports'>
                            <span className="kr kr-reports" />
                            <span className="name">Daily Reports</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                    <li onClick={(event)=>this.handleClick(event, '/messages')} className={(this.state.selected === '/messages') ? 'selected': ''}>
                        <span className="top-corner" />
                        <NavLink to="/sm-admin/messages" data-for='messages-tooltip' data-tip='Messages'>
                            <span className="kr kr-messages" />
                            <span className="name">Messages</span>
                        </NavLink>
                        <span className="bottom-corner" />
                    </li>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='messages-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='dashboard-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='dentists-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='patients-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='av-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='dr-tooltip'/>
                        <ReactTooltip className={this.props.isLeftMenuOpened && 'hide_tooltip'} id='cases tooltip'/>
                </ul>
            </ScrollArea>
        );
    }
}

export default class Nav extends Component {
    constructor(props) {
        super(props);
        this.toggleMenu = props.toggleMenu();
        this.navBig = document.body.clientWidth > globals.NAV_BIG
        this.state = {
            isLeftMenuOpened:  this.navBig,
        }
    }

    getNavClassNames() {
        let classNames = 'site-nav ';
        if(!this.navBig && this.props.mini) {
            classNames +=' mini '
        }
        return classNames
    }

    setLeftMenu =() => {
        if(this.navBig){
            this.state.isLeftMenuOpened = !this.state.isLeftMenuOpened;
        }
        this.props.toggleNav()
    }

    render () {
        return (
            <nav className={this.state.isLeftMenuOpened ? this.getNavClassNames() : this.getNavClassNames() + `${this.navBig && ' collapsed_left_menu'}`+ ' ' + `${!this.navBig && !this.isLeftMenuOpened && ' collapsed_mobile_left_menu'}`}>
                {this.navBig ? <NavHead {...this.props} isLeftMenuOpened={this.state.isLeftMenuOpened}
                                   setLeftMenu={this.setLeftMenu}/> :
                    <NavHead  {...this.props}/>
                }
                <NavList isLeftMenuOpened={this.state.isLeftMenuOpened} toggleNav={() => this.props.toggleNav()}/>
            </nav>
        )
    }


}


// WEBPACK FOOTER //
// ./src/shared/components/nav/index.js